var _g, _g2, _path, _path2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350.1,
    height: 400,
    viewBox: "0 0 92.631 105.833",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2.672
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.294 52.917a44.98 44.98 0 01-44.979 44.979 44.98 44.98 0 01-44.979-44.98 44.98 44.98 0 0144.98-44.978 44.98 44.98 0 0144.978 44.979z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.315 7.938c24.842 0 44.98 20.137 44.98 44.979 0 24.841-20.138 44.979-44.98 44.979",
    fill: "#666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.672
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.914 33.033h68.792M11.933 40.993h68.792M11.923 48.955h68.792M11.914 56.846h68.792M11.933 64.806h68.792M11.923 72.767h68.792"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.453 87.306V18.514M34.413 87.286V18.495M42.374 87.296V18.505M50.265 87.306V18.514M58.225 87.286V18.495M66.186 87.296V18.505"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.503 26.458h47.625a2.64 2.64 0 012.646 2.646V76.73a2.64 2.64 0 01-2.646 2.646H22.503a2.64 2.64 0 01-2.646-2.646V29.104a2.64 2.64 0 012.646-2.646z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.149 29.104h42.333c1.466 0 2.646 1.416 2.646 3.175v41.275c0 1.76-1.18 3.175-2.646 3.175H25.149c-1.466 0-2.646-1.416-2.646-3.175V32.28c0-1.759 1.18-3.175 2.646-3.175z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.544 0L19.857 66.146h19.844l-6.615 39.687 39.688-66.146-19.924-.016z",
    fill: "#ff9600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.086 105.833l39.688-66.146v13.23zM59.544 0L46.315 39.687l6.535-.016z",
    fill: "#ff0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLogo);
export default __webpack_public_path__ + "static/media/My Logo.3bed241651041d86f1f36a25c0649077.svg";
export { ForwardRef as ReactComponent };